module.exports = __webpack_public_path__ + "img/bg-sidemenu-narrow.ff16b269.png";